import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CameraComponent from "../CameraComponent";

function CameraModal({ showCamera, setShowCamera, handleUpload, setLoading, close, loading }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    overflow: "hidden",
    // maxHeight: "90vh",
    width: "100%",
    height: "100%",
  };

  return (
    <Modal
      open={showCamera}
      onClose={() => setShowCamera(false)}
      aria-labelledby="camera-modal"
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box sx={style}>
        <CameraComponent setShowCamera={setShowCamera} handleUpload={handleUpload} setLoading={setLoading} close={close} loading={loading} />
      </Box>
    </Modal>
  );
}

export default CameraModal;
